/**
 * @author      calvin@zumper.com (Calvin Yau)
 * @copyright   Copyright (c) 2020, Zumper
 * @description multifamilyTourTimePicker
 */

import { filterActions } from '@zumper/redux-ignore'

import * as constants from './constants'
import { multifamilyTourTimePicker as rootReducer } from './reducers/index'

export default filterActions(rootReducer, Object.values(constants))
